import { useEffect } from 'react';

const TOKEN_PARAM = 'benefit_code_token';
const TOKEN_PATTERN = /^[A-Za-z0-9_-]+$/;

// Capture the promo code token monkeyfitpass.com appends to the URL, store
// it for the API call in useFetchBenefits, then strip it from the visible
// URL so a shared link does not carry it along.
const useBenefitToken = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get(TOKEN_PARAM);

    if (!token) return;

    try {
      if (TOKEN_PATTERN.test(token)) {
        sessionStorage.setItem(TOKEN_PARAM, token);
      }
    } catch {
      // sessionStorage unavailable (e.g. private browsing) — continue without it.
    }

    params.delete(TOKEN_PARAM);
    const query = params.toString();
    const newUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
    window.history.replaceState(null, '', newUrl);
  }, []);
};

export default useBenefitToken;
